// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AuditFacets = zod.object({
  "actions": zod.array(zod.string()),
  "actors": zod.array(zod.string()),
  "entity_types": zod.array(zod.string()),
  "event_families": zod.array(zod.string()),
  "outcomes": zod.array(zod.string())
});

export type AuditFacets = zod.input<typeof AuditFacets>;
export type AuditFacetsOutput = zod.output<typeof AuditFacets>;
